<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M19.7493 9.76582C20.1118 9.36709 20.0768 8.75595 19.6711 8.40116L10.7328 0.580135C10.3271 0.225345 9.67668 0.232777 9.27951 0.59689L0.310874 8.81815C-0.0862924 9.18226 -0.105786 9.79261 0.267715 10.1808L0.492571 10.415C0.865615 10.8033 1.4686 10.8496 1.83852 10.5181L2.50878 9.91785V18.7056C2.50878 19.2447 2.94565 19.6812 3.48442 19.6812H6.98042C7.51919 19.6812 7.95606 19.2447 7.95606 18.7056V12.5577H12.4152V18.7056C12.4075 19.2444 12.793 19.6808 13.3318 19.6808H17.0366C17.5754 19.6808 18.0123 19.2444 18.0123 18.7052V10.0416C18.0123 10.0416 18.1974 10.2038 18.4258 10.4045C18.6538 10.6049 19.1326 10.4442 19.4952 10.0451L19.7493 9.76582Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgHome',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>

<style>

</style>
